import { forwardRef, useState } from 'react';
import { TextField, TextFieldProps } from '../TextField/TextField';
import { PasswordToggle } from './PasswordToggle';

export type PasswordFieldProps = Omit<TextFieldProps, 'type' | 'adornment' | 'adornmentPosition'>;

export const PasswordField = forwardRef<HTMLInputElement, TextFieldProps>((props, forwardedRef) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      adornment={<PasswordToggle showPassword={showPassword} togglePassword={togglePassword} />}
      adornmentPosition="right"
      ref={forwardedRef}
      {...props}
    />
  );
});

PasswordField.displayName = 'PasswordField';
